<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    mounted() {
        // if (this.user.isLogin === false) {
        //     if (this.ClientType === 1) {
        //         this.setLoginPop(true)
        //     } else {
        //         if (this.$route.name !== 'MLogin') {
        //             window.location.href = '/m/login'
        //             // this.$router.push({
        //             //     name: 'MLogin'
        //             // })
        //         }
        //     }
        // }
    },
    methods: {
        ...mapActions([
            'setLoginPop'
        ])
    },
    watch: {
        // ClientType: {
        //     handler(newV) {
        //         if (newV === 2 && this.user.isLogin === false) {
        //             if (this.$route.name !== 'MLogin') {
        //                 window.location.href = '/m/login'
        //                 // this.$router.push({
        //                 //     name: 'MLogin'
        //                 // })
        //             }
                    
        //         }
        //     },
        //     immediate: true,
        //     deep: true
        // },
        // user: {
        //     handler(newV) {
        //         if (newV.isLogin === false) {
        //             if (this.ClientType === 1) {
        //                 this.setLoginPop(true)
        //             } else {
        //                 if (this.$route.name !== 'MLogin') {
        //                     window.location.href = '/m/login'
        //                     // this.$router.push({
        //                     //     name: 'MLogin'
        //                     // })
        //                 }
        //             }
        //         }
        //     },
        //     deep: true
        // }
    },
    computed: {
        ...mapGetters(['user', 'ClientType'])
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/reset";
    // @import "~common/scss/variable";
    // @import "~common/scss/base";
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        // background: #F8F8F8;
        color: #303133;
        font-size: 14px;
        // height: 100%;
        height: 100vh;
    }

    // body::-webkit-scrollbar {
    //     width: 4px;
    // }
    // body::-webkit-scrollbar-thumb {
    //     border-radius: 2px;
    //     background:rgb(172, 172, 172);
    // }
    // body::-webkit-scrollbar-track {
    //     border-radius: 2px;
    //     background: #f4f4f4;
    // }
    // body::-webkit-scrollbar {
    //     display: none;
    // }
</style>
